export default __webpack_public_path__ + "static/media/37k.70f2af06.md";